import {
    FETCH_PARTNERS_SUCCESS,
    CREATE_PARTNER_SUCCESS,
  } from '../actions/types';
  
  const INITIAL_STATE = {
    partners: null,
    partner: null,
  };
  
  export default function partnerReducer (state=INITIAL_STATE, action) {
    switch (action.type) {
      case FETCH_PARTNERS_SUCCESS:
        return { ...state, partners: action.payload.partners };
      case CREATE_PARTNER_SUCCESS:
        return { ...state, partner: action.payload.partner };
      default:
        return state;
    }
  };

